import { BaseTenantLinksDto } from '../../shared/dtos/base-tenant-links.dto';

/**
 * Rental reservation links DTO
 */
export class RentalReservationLinksDto extends BaseTenantLinksDto {}
